class footerAccordion extends HTMLElement {
  constructor() {
    super();

    if (this.classList.contains('admin-panel--no-js')) return;

    this.toggleContent = '.footer__accordion__content';
    this.boxes = this.querySelectorAll('.footer__accordion__heading');

    if (!this.boxes.length) return;

    // ✅ Open first & last by default
    this.openDefaultAccordions();

    this.bindEvents();
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }

  openDefaultAccordions() {
    const total = this.boxes.length;

    if (total === 0) return;

    const first = this.boxes[0];
    const last = this.boxes[total - 1];

    // Open first
    first.setAttribute('open', '');
    first.classList.add('footer__accordion-opening');

    // Open last (avoid duplicate if only one)
    if (total > 1) {
      last.setAttribute('open', '');
      last.classList.add('footer__accordion-opening');
    }
  }

  bindEvents() {
    const _this = this;

    this.boxes.forEach(box => {
      box.addEventListener('click', event => {
        event.preventDefault();

        if (window.innerWidth > 576) return false;

        const details = event.currentTarget;
        const childs = _this.querySelectorAll('[open]');

        if (details.hasAttribute('open')) {
          details.classList.remove('footer__accordion-opening');
          setTimeout(() => {
            details.removeAttribute('open');
          }, 500);
        } else {
          details.setAttribute('open', '');
          setTimeout(() => {
            _this.resizeHandler();
            details.classList.add('footer__accordion-opening');
          }, 0);
        }
      });
    });
  }

  resizeHandler() {
    const boxes = this.querySelectorAll('[open]+' + this.toggleContent);
    boxes.forEach(box => {
      box.style.setProperty('--scroll-height', (box.scrollHeight + 1) + "px");
    });
  }
}

customElements.define('footer-accordion', footerAccordion);